var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "robot_wrap",
      staticClass: "robot_wrap",
      style: { "z-index": ["9999", "1999"][+_vm.robotHide] },
    },
    [
      _c(
        "div",
        {
          ref: "robot_tips",
          staticClass: "robot_tips",
          class: { fadeOutRight: _vm.show, fadeInRight: !_vm.show },
          on: { mousedown: _vm.mouseDown },
        },
        [
          _c(
            "el-badge",
            {
              staticClass: "my-badge",
              staticStyle: { width: "100%" },
              attrs: {
                value: _vm.deepingTaskCount,
                hidden: !_vm.deepingTaskCount,
              },
            },
            [_c("img", { attrs: { src: _vm.robot, alt: "", srcset: "" } })]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show",
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.waiting,
              expression: "waiting",
            },
          ],
          ref: "robotContent",
          staticClass: "robotContent",
          class: { fadeInBottomRight: _vm.show, fadeOutBottomRight: !_vm.show },
        },
        [
          _c(
            "div",
            { staticClass: "closeContent", on: { click: _vm.closeContent } },
            [_c("i", { staticClass: "el-icon-close" })]
          ),
          _vm.activeIndex == 1
            ? _c("robot-view1", {
                key: 1,
                ref: "robotView1",
                staticClass: "robot-view h-auto",
              })
            : _vm.activeIndex == 2
            ? _c("robot-view2", {
                key: 2,
                staticClass: "robot-view",
                staticStyle: { "max-height": "432px" },
              })
            : _vm.activeIndex == 3
            ? _c("robot-view3", {
                key: 3,
                staticClass: "robot-view",
                staticStyle: { "max-height": "432px" },
              })
            : _c("robot-view", {
                key: 4,
                staticClass: "robot-view",
                attrs: { deepingTaskCount: _vm.deepingTaskCount },
              }),
        ],
        1
      ),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
        staticClass: "zezhao",
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.closeContent.apply(null, arguments)
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }